import EventsCoupon from './_events-coupon.js'

export default {
  name: 'MatchesCoupon',
  values: {
    eventsCoupon: {
      configSet: EventsCoupon,
      configValues: {
        initialExpandedGroups: 3,
        enableSorting: true,
        eventList: {
          header: {
            showTitle: false,
            container: {
              style: {
                _desktop_justifyContent: 'end',
              },
            },
          },
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
